var Vendd = (function (Vendd) {
    'use strict';

    Vendd.MessageBus.subscribe(Vendd.InlineAdmin.Messages.CreateCookieForInlineAdmin, Vendd.InlineAdmin, function (envelope) {

        var options = {
            async: false,
            method: 'GET',
            url: 'api/InlineAdmin/CreateCookieForInlineAdmin',
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        var redirectUrl = envelope.message.data.redirectUrl;

        function onSuccess(response) {
            if (response.data == false) {
                response.redirectUrl = envelope.message.data.redirectUrl;
                Vendd.MessageBus.publish(Vendd.InlineAdmin, new Vendd.InlineAdmin.Messages.CreateCookieForInlineAdminFailure(response, envelope.message.data.redirectUrl));
                return;
            }
            response.redirectUrl = envelope.message.data.redirectUrl;
            response.username = envelope.message.data.username;
            response.password = envelope.message.data.password;

            Vendd.MessageBus.publish(Vendd.InlineAdmin, new Vendd.InlineAdmin.Messages.CreateCookieForInlineAdminSuccess(response, envelope.message.data.redirectUrl));

        };

        function onFailure(response) {

            Vendd.MessageBus.publish(Vendd.InlineAdmin, new Vendd.InlineAdmin.Messages.CreateCookieForInlineAdminFailure(response));
        };

        Vendd.Service.call(options);

    });

    Vendd.MessageBus.subscribe(Vendd.InlineAdmin.Messages.CheckForInlineAdmin, Vendd.InlineAdmin, function (envelope) {
        var options = {
            method: 'POST',
            url: 'api/InlineAdmin/CheckForInlineAdmin',
            data: { 
                ItemId: window.inlineAdminGlobalVariables.ItemId,
                ItemPathChecksum: window.inlineAdminGlobalVariables.ItemPathChecksum,
                ItemCode: window.inlineAdminGlobalVariables.ItemCode,
                PageTemplate: window.inlineAdminGlobalVariables.PageTemplate,
                EntityId: window.inlineAdminGlobalVariables.EntityId,
                EntityCode: window.inlineAdminGlobalVariables.EntityCode,
                IsEditable: window.inlineAdminGlobalVariables.IsEditable === 'True',
                RequestNewGuest: envelope && envelope.message && envelope.message.data && envelope.message.data.RequestNewGuest
            },
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        function onSuccess(response) {
            Vendd.MessageBus.publish(Vendd.InlineAdmin, new Vendd.InlineAdmin.Messages.CheckForInlineAdminSuccess(response));
        };

        function onFailure(response) {
            Vendd.MessageBus.publish(Vendd.InlineAdmin, new Vendd.InlineAdmin.Messages.CheckForInlineAdminFailure(response));
        };

        Vendd.Service.call(options);

    });

    return Vendd;

})(Vendd || {});